module.exports = __webpack_public_path__ + "img/woo-01.2e9a2619.png";